export default __webpack_public_path__ + "static/media/celebrate.a716c8ca62e1363d7b64c82e57254d80.svg";